import { render, staticRenderFns } from "./ClientesSiczap.vue?vue&type=template&id=e95fb8d6"
import script from "./ClientesSiczap.vue?vue&type=script&lang=js"
export * from "./ClientesSiczap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports